export enum DonationFromStatusTypeEnum {
  DONATION = 'DONATION',
  PLEDGED = 'PLEDGED',
}
